// extracted by mini-css-extract-plugin
module.exports = {"starView":"index_starView__2WRUo","view":"index_view__2o5FR","star1":"index_star1__1rorN","star2":"index_star2__3ocsr","diImg":"index_diImg__3hsuf","caiImg":"index_caiImg__AMC_N"};